import { ChangeDetectionStrategy, Component, LOCALE_ID, inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DriversSalaryV2StateService } from '../_services/drivers-salary-v2.state.service';

@Component({
	selector: 'app-salary-month-status',
	standalone: true,
	imports: [DatePipe, MatButtonModule, MatIconModule, MatProgressSpinnerModule, MatTooltipModule],
	providers: [{ provide: LOCALE_ID, useValue: 'pl-PL' }],
	templateUrl: './salary-month-status.component.html',
	styleUrl: './salary-month-status.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SalaryMonthStatusComponent {
	readonly state = inject(DriversSalaryV2StateService);

	readonly unlockTooltip = 'Cofa rozliczenie miesiąca i odblokowuje edycję danych.';
}
